import './ChatItemDetail.less';

import React, { useRef } from 'react';
import { useReframe } from 'nike-re-framejs';

import { getTicketWinValue } from '@/mytickets/utils';
import { formatStakeMoney } from '@/betslip/money';
import AnalyseCommentIcon from 'nike-ui/src/icons/svg/analyse-comment-icon-sv.svg';
import { accountUserData$ } from '@/account/subs';

const mena = 'EUR';

function ChatAnalyseDetail({ analysis, onClick }) {
    const ref = useRef(null);
    const { subscribe } = useReframe();
    const { idZak: customerId } = subscribe(accountUserData$);
    const participants = analysis.pick?.participants;
    const tournament = analysis.pick?.tournament;
    const market = analysis.pick?.market;
    const text = participants
        ? participants.length > 1
            ? `${participants[0]} vs ${participants[1]}`
            : `${tournament} - ${market}`
        : analysis.opponents;

    return (
        <div ref={ref} data-atid="analyse-detail-slider-item" onClick={onClick}>
            <div className="ticket-detail-slider-item-content">
                <AnalyseCommentIcon />
                <div className="item-values">
                    <div className={'ticket-value-analyse-stake ticket-state-value'}>{text}</div>
                    <div className="item-value-win">
                        {formatStakeMoney(analysis.ticket ? analysis.ticket : analysis, customerId, false, true) +
                            '/' +
                            getTicketWinValue(analysis.ticket ? analysis.ticket : analysis, mena)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChatAnalyseDetail;
